<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="permission-modal"
      dialog-width="30rem"
      dialog-height="40rem"
    >
      <template #header>
        権限の追加
      </template>
      <div class="jps-modal-content">
        <SearchBoxSimple :ss="ss" />
        <SearchCount :ss="ss" />
        <table class="jps-table" v-if="ss.searched">
          <tbody>
            <tr v-for="org in ss.state.result.list" :key="org.id">
              <td>{{ ls(org.name) }}</td>
              <td>
                <button class="jps-button" @click="addOrg(org)">追加</button>
              </td>
            </tr>
          </tbody>
        </table>
        <SearchInfiniteLoading :ss="ss" />
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.cancel) }}</button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import type { BaseModal } from '#components'

const { ls } = useI18n()
const { searchOrganization } = useOrganization()

interface Props {
}
const props = withDefaults(defineProps<Props>(),{
})

const modal = ref<InstanceType<typeof BaseModal>>()
const openAwait = async () => {
  return await modal.value.openAwait<Organization>()
}
defineExpose({ openAwait })

const ss: Ref<SearchStore<Organization>> = ref(null)
onBeforeMount(() => {
  ss.value = useSearch<Organization>(
    {
      searchFields: [
        {
          key: 'name.ja',
          type: 'keyword',
          name: { ja: '名前', en: 'Name' },
        },
      ],
    },
    searchOrganization,
    {
      configSyncRoute: false,
      configNoCache: true,
      configNoLoading: true,
      configFreeze: false,
    }
  )
})

const addOrg = (org: Organization) => {
  modal.value.resolve(org)
}
</script>
